import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Heading,
  HStack,
  Container,
  Flex,
  Text,
  Spinner,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  VStack,
  Center,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
  InputRightElement,
  IconButton,
  SimpleGrid,
  Grid,
  useToast,
} from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import API_CONFIG from "../../Configuration/apiConfig";
import apiClient from "../../Configuration/apiClient";
import "./SoftDrinks.css";
import styles from "components/Styles/AsmStyles.js";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import "components/Styles/MsdStyles.css";
import { SearchIcon, CloseIcon } from "@chakra-ui/icons";
import { Icon, Divider } from "@chakra-ui/react";
import {
  FiRotateCw,
  FiShoppingBag,
  FiTag,
  FiPackage,
  FiExternalLink,
  FiChevronLeft,
  FiChevronRight,
  FiMapPin,
  FiHash,
  FiImage,
  FiGrid,
  FiX,
  FiEye,
  FiCheckCircle,
  FiDownload,
  FiEdit,
} from "react-icons/fi";
import { FiList } from "react-icons/fi";
import { MdStorefront, MdStore } from "react-icons/md";
import { InfoCard, ImageCard, ProductTable } from "./cards";
import EditImageModal from "./EditImageModal";
function SoftDrinkDpEdit({ fromDate, toDate }) {
  const [regionList, setRegionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [asmList, setAsmList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedAsm, setSelectedAsm] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStoreImages, setSelectedStoreImages] = useState([]);
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [scoreBreakdown, setScoreBreakdown] = useState(null);
  const [selectedMonthData, setSelectedMonthData] = useState(null);
  const [productSummary, setProductSummary] = useState([]);
  const [actualImageUrl, setActualImageUrl] = useState("");
  const [annotatedImageUrl, setAnnotatedImageUrl] = useState("");
  const [modalActualImages, setModalActualImages] = useState([]);
  const [modalAnnotatedImages, setModalAnnotatedImages] = useState([]);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [shelfInfo, setShelfInfo] = useState([]);
  // Cooler images state
  const [modalCoolerActualImages, setModalCoolerActualImages] = useState([]);
  const [modalCoolerAnnotatedImages, setModalCoolerAnnotatedImages] = useState(
    [],
  );
  const [modalCoolerImageIndex, setModalCoolerImageIndex] = useState(0);
  const [coolerActualImageUrl, setCoolerActualImageUrl] = useState("");
  const [coolerAnnotatedImageUrl, setCoolerAnnotatedImageUrl] = useState("");
  const [activationImageUrl, setActivationImageUrl] = useState("");
  const [isActivationImageOpen, setIsActivationImageOpen] = useState(false);
  const [loadingActivationImage, setLoadingActivationImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [loadingCity, setLoadingCity] = useState(false);
  const [loadingSubRegion, setLoadingSubRegion] = useState(false);
  const [loadingChannel, setLoadingChannel] = useState(false);
  const [loadingType, setLoadingType] = useState(false);
  const [loadingAsm, setLoadingAsm] = useState(false);
  const [loadingStores, setLoadingStores] = useState(false);
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [error, setError] = useState(" ");
  const [redScore, setRedScore] = useState(0);
  const [availabilityScore, setAvailabilityScore] = useState(0);
  const [activationScore, setActivationScore] = useState(0);
  const [coolerScore, setCoolerScore] = useState(0);
  const [bonusScore, setBonusScore] = useState(0);
  const [totalOutlets, setTotalOutlets] = useState(0);
  const [loadingScores, setLoadingScores] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStores, setFilteredStores] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [isRecalculating, setisRecalculating] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [imageRotation, setImageRotation] = useState(0);

  const [isValidatingAvl, setIsValidatingAvl] = useState(false);
  const [isValidatingAct, setIsValidatingAct] = useState(false);

  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();

  const toast = useToast();
  // Helper function to create date range body
  const getMonthRangeBody = () => {
    const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(Number);
    const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);
    return {
      from: {
        date: fromDay,
        month: fromMonthNum,
        year: fromYear,
      },
      to: {
        date: toDay,
        month: toMonthNum,
        year: toYear,
      },
    };
  };

  const handlePrevModalImage = () => {
    if (modalImageIndex > 0) {
      const newIndex = modalImageIndex - 1;
      setModalImageIndex(newIndex);
      setActualImageUrl(modalActualImages[newIndex] || "");
      setAnnotatedImageUrl(modalAnnotatedImages[newIndex] || "");
    }
  };

  // Helper function to download image
  const handleDownloadImage = async (imageUrl) => {
    if (!imageUrl) return;

    try {
      const response = await fetch(imageUrl, {
        mode: "cors",
        cache: "no-cache",
      });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "image.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.warn(
        "Direct download failed (likely CORS), falling back to new tab:",
        error,
      );
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "image.jpg";
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleNextModalImage = () => {
    if (modalImageIndex < modalActualImages.length - 1) {
      const newIndex = modalImageIndex + 1;
      setModalImageIndex(newIndex);
      setActualImageUrl(modalActualImages[newIndex] || "");
      setAnnotatedImageUrl(modalAnnotatedImages[newIndex] || "");
    }
  };

  const handleViewActivation = async (detail) => {
    try {
      setLoadingActivationImage(true);
      const s3Path = detail?.s3ActualPath;
      if (!s3Path) return;
      const [toYear, toMonthNum] = toDate.split("-").map(Number);
      const urls = await generatePresignedUrls([s3Path], toMonthNum, toYear);
      setActivationImageUrl(urls[0] || "");
      setIsActivationImageOpen(true);
    } catch (err) {
      console.error("Failed to load activation image:", err);
    } finally {
      setLoadingActivationImage(false);
    }
  };

  const handlePrevCoolerImage = () => {
    if (modalCoolerImageIndex > 0) {
      const newIndex = modalCoolerImageIndex - 1;
      setModalCoolerImageIndex(newIndex);
      setCoolerActualImageUrl(modalCoolerActualImages[newIndex] || "");
      setCoolerAnnotatedImageUrl(modalCoolerAnnotatedImages[newIndex] || "");
    }
  };

  const handleNextCoolerImage = () => {
    if (modalCoolerImageIndex < modalCoolerActualImages.length - 1) {
      const newIndex = modalCoolerImageIndex + 1;
      setModalCoolerImageIndex(newIndex);
      setCoolerActualImageUrl(modalCoolerActualImages[newIndex] || "");
      setCoolerAnnotatedImageUrl(modalCoolerAnnotatedImages[newIndex] || "");
    }
  };

  // Search handler function
  const handleSearch = (query) => {
    setSearchQuery(query);
    const filtered = stores.filter((store) =>
      store.storeName?.toLowerCase().includes(query.toLowerCase()),
    );
    const sortedFiltered = filtered.sort((a, b) => {
      const nameA = (a.storeName || "").toLowerCase();
      const nameB = (b.storeName || "").toLowerCase();
      return nameA.localeCompare(nameB);
    });
    setFilteredStores(sortedFiltered);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (stores.length > 0) {
      setFilteredStores(stores);
    }
  }, [stores]);

  const regionOptions = regionList.map((item) => ({
    value: item,
    label: item,
  }));
  const asmOptions = asmList.map((item) => ({ value: item, label: item }));
  const cityOptions = districtList.map((item) => ({
    value: item,
    label: item,
  }));
  const channelOptions = channelList.map((item) => ({
    value: item,
    label: item,
  }));
  const typeOptions = typeList.map((item) => ({ value: item, label: item }));
  const menuPortalTarget = typeof window !== "undefined" ? document.body : null;
  const selectBaseProps = useMemo(
    () => ({
      className: "sdx-dropdown",
      classNamePrefix: "sdx-select",
      menuPortalTarget: menuPortalTarget ?? undefined,
      menuPosition: "fixed",
      styles: {
        menuPortal: (base) => ({ ...base, zIndex: 1000 }),
      },
    }),
    [menuPortalTarget],
  );

  const cards = [
    {
      label: " Average Total RedScore",
      value: redScore,
      variant: "sd-score-card--red",
    },
    {
      label: " Average Availability",
      value: availabilityScore,
      variant: "sd-score-card--green",
    },
    {
      label: "Average Activation",
      value: activationScore,
      variant: "sd-score-card--blue",
    },
    {
      label: "Average Cooler",
      value: coolerScore,
      variant: "sd-score-card--peach",
    },
    {
      label: "Average Cooler Bonus",
      value: bonusScore,
      variant: "sd-score-card--blue",
    },
  ];

  const productColumnDefs = [
    {
      headerName: "Company",
      field: "product.productCompany.productCompanyName",
      flex: 1,
    },
    {
      headerName: "Brand",
      field: "product.productBrand.productBrandName",
      flex: 1,
    },
    { headerName: "Pack Type", field: "product.packType", flex: 0.5 },
    { headerName: "Pack Size", field: "product.packSize", flex: 0.5 },
    { headerName: "Product Name", field: "product.productName", flex: 1.5 },
    { headerName: "Count", field: "productCount", flex: 0.5 },
  ];

  const generatePresignedUrls = async (s3Paths, month, year) => {
    const presignedPromises = s3Paths.map(async (s3Path) => {
      const presignedEndpoint = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${encodeURIComponent(
        s3Path,
      )}&bucketName=imageinsightimagesbeverages&operation=download&month=${month}&year=${year}&ResponseContentDisposition=attachment`;
      try {
        const response = await fetch(presignedEndpoint);
        if (!response.ok) throw new Error("Failed to fetch presigned URL");
        const presignedUrl = await response.text();
        return presignedUrl.trim();
      } catch (err) {
        console.error("Failed to generate presigned URL:", err);
        return null;
      }
    });
    return (await Promise.all(presignedPromises)).filter((url) => url);
  };

  const handleStoreClick = async (store) => {
    setSelectedStore(store);
    try {
      const month = store.month;
      const year = store.year;
      const monthData = {
        year,
        month,
        label: new Date(year, month - 1).toLocaleString("default", {
          month: "long",
        }),
      };
      setSelectedMonthData(monthData);
      const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(Number);
      const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);
      const requestBody = {
        from: {
          date: fromDay,
          month: fromMonthNum,
          year: fromYear,
        },
        to: {
          date: toDay,
          month: toMonthNum,
          year: toYear,
        },
      };

      const res = await apiClient.post(
        `${API_CONFIG.BASE_URL}/red-master/store-details?storeId=${store.storeId}`,
        requestBody,
      );

      setSelectedStoreDetails(res.data || null);
      if (res.data?.imagePaths && res.data.imagePaths.length > 0) {
        const fullImagePaths = res.data.imagePaths.map((path) => `${path}`);
        const urls = await generatePresignedUrls(
          fullImagePaths,
          monthData.month,
          monthData.year,
        );
        setSelectedStoreImages(urls);
      } else {
        setSelectedStoreImages([]);
      }
      if (res.data?.storeId) {
        const breakdownUrl = `${API_CONFIG.BASE_URL}/red-master/${res.data.storeId}/score-breakdown`;
        const breakdownRes = await apiClient.post(breakdownUrl, requestBody);

        const breakdownData = breakdownRes.data;
        setScoreBreakdown(breakdownData);
        setProductSummary(breakdownData?.availability?.products || []);
        const actualPaths =
          breakdownData?.availability?.imagePathResponse?.s3pathActualFile ||
          [];
        const annotatedPaths =
          breakdownData?.availability?.imagePathResponse?.s3pathAnnotatedFile ||
          [];
        const coolerActualPaths =
          breakdownData?.cooler?.imagePathResponse?.s3pathActualFile || [];
        const coolerAnnotatedPaths =
          breakdownData?.cooler?.imagePathResponse?.s3pathAnnotatedFile || [];

        const shelves = actualPaths.map((_, index) => ({
          shelfNumber: index + 1,
          label: `Shelf ${index + 1}`,
        }));
        setShelfInfo(shelves);

        if (actualPaths.length > 0) {
          const actualUrls = await generatePresignedUrls(
            actualPaths,
            month,
            year,
          );
          setModalActualImages(actualUrls);
          setActualImageUrl(actualUrls[0] || "");
        } else {
          setModalActualImages([]);
          setActualImageUrl("");
        }
        if (annotatedPaths.length > 0) {
          const annotatedUrls = await generatePresignedUrls(
            annotatedPaths,
            month,
            year,
          );
          setModalAnnotatedImages(annotatedUrls);
          setAnnotatedImageUrl(annotatedUrls[0] || "");
        } else {
          setModalAnnotatedImages([]);
          setAnnotatedImageUrl("");
        }
        if (coolerActualPaths.length > 0) {
          const coolerActualUrls = await generatePresignedUrls(
            coolerActualPaths,
            month,
            year,
          );
          setModalCoolerActualImages(coolerActualUrls);
          setCoolerActualImageUrl(coolerActualUrls[0] || "");
        } else {
          setModalCoolerActualImages([]);
          setCoolerActualImageUrl("");
        }
        if (coolerAnnotatedPaths.length > 0) {
          const coolerAnnotatedUrls = await generatePresignedUrls(
            coolerAnnotatedPaths,
            month,
            year,
          );
          setModalCoolerAnnotatedImages(coolerAnnotatedUrls);
          setCoolerAnnotatedImageUrl(coolerAnnotatedUrls[0] || "");
        } else {
          setModalCoolerAnnotatedImages([]);
          setCoolerAnnotatedImageUrl("");
        }
        setModalImageIndex(0);
        setModalCoolerImageIndex(0);
      } else {
        setScoreBreakdown(null);
        setProductSummary([]);
        setShelfInfo([]);
        setActualImageUrl("");
        setAnnotatedImageUrl("");
      }
      setCurrentImageIndex(0);
      setImageRotation(0);
      setActiveTab(0);
    } catch (err) {
      console.error("Failed to load store details:", err);
      setError("Failed to load store details.");
      setSelectedStoreDetails(null);
      setScoreBreakdown(null);
      setProductSummary([]);
      setSelectedStoreImages([]);
      setSelectedMonthData(null);
      setShelfInfo([]);
      setActualImageUrl("");
      setAnnotatedImageUrl("");
    }
  };

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.ResizeObserver === "undefined"
    ) {
      return;
    }
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserverPatched extends (
      OriginalResizeObserver
    ) {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
    return () => {
      window.ResizeObserver = OriginalResizeObserver;
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!fromDate || !toDate) {
        setRedScore(0);
        setAvailabilityScore(0);
        setActivationScore(0);
        setCoolerScore(0);
        setBonusScore(0);
        setTotalOutlets(0);
        setStores([]);
        return;
      }

      setLoadingScores(true);
      try {
        let filters = {};
        if (selectedRegions.length > 0) {
          filters = {
            dropdown1: selectedRegions.map((r) => r.value).join(", "),
            dropdown2: selectedAsm.map((sr) => sr.value).join(", "),
            dropdown3: selectedDistrict.map((c) => c.value).join(", "),
            dropdown4: selectedChannels.map((ch) => ch.value).join(", "),
            dropdown5: selectedTypes.map((t) => t.value).join(", "),
          };
        }
        const [fromYear, fromMonthNum, fromDay] = fromDate
          .split("-")
          .map(Number);
        const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);
        const requestBody = {
          filters: filters,
          timePeriod: {
            from: {
              date: fromDay,
              month: fromMonthNum,
              year: fromYear,
            },
            to: {
              date: toDay,
              month: toMonthNum,
              year: toYear,
            },
          },
        };
        const scoresRes = await apiClient.post(
          `${API_CONFIG.BASE_URL}/red-master/store-scores`,
          requestBody,
        );
        setRedScore(scoresRes.data.totalRedScore || 0);
        setAvailabilityScore(scoresRes.data.availabilityScore || 0);
        setActivationScore(scoresRes.data.activationScore || 0);
        setCoolerScore(scoresRes.data.coolerScore || 0);
        setBonusScore(scoresRes.data.coolerBonus || 0);
        setTotalOutlets(scoresRes.data.totalOutlets || 0);

        const storesRes = await apiClient.post(
          `${API_CONFIG.BASE_URL}/red-master/store-search`,
          requestBody,
        );
        const sortedStores = (storesRes.data || []).sort((a, b) => {
          const nameA = (a.storeName || "").toLowerCase();
          const nameB = (b.storeName || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });
        setStores(sortedStores);
      } catch (err) {
        console.error("Failed to load data:", err);
        setError("Failed to load data.");
      } finally {
        setLoadingScores(false);
        setLoadingStores(false);
      }
    };
    fetchData();
  }, [
    selectedRegions,
    selectedAsm,
    selectedDistrict,
    selectedChannels,
    selectedTypes,
    fromDate,
    toDate,
  ]);

  useEffect(() => {
    if (!fromDate || !toDate) return;
    const fetchRegions = async () => {
      setLoadingRegions(true);
      try {
        const requestBody = getMonthRangeBody();
        const userId =
          localStorage.getItem("userId") || sessionStorage.getItem("userId");
        const res = await apiClient.request({
          method: "POST",
          url: `${API_CONFIG.BASE_URL}/red-master/regions`,
          data: requestBody,
          params: { userId },
        });
        const regions = Array.isArray(res.data) ? res.data : [res.data];
        setRegionList(regions);
        setSelectedRegions([]);
        setSelectedAsm([]);
        setAsmList([]);
        setSelectedDistrict([]);
        setDistrictList([]);
        setSelectedChannels([]);
        setChannelList([]);
        setSelectedTypes([]);
        setTypeList([]);
      } catch (err) {
        console.error("Failed to load regions:", err);
        setError("Failed to load region dropdown data.");
        setRegionList([]);
      } finally {
        setLoadingRegions(false);
      }
    };
    fetchRegions();
  }, [fromDate, toDate]);

  useEffect(() => {
    if (selectedRegions.length === 0 || !fromDate || !toDate) {
      setAsmList([]);
      setSelectedAsm([]);
      return;
    }
    const fetchAsms = async () => {
      setLoadingSubRegion(true);
      try {
        const requestBody = {
          filters: {
            dropdown1: selectedRegions.map((r) => r.value).join(", "),
          },
          timePeriod: getMonthRangeBody(),
        };
        const res = await apiClient.post(
          `${API_CONFIG.BASE_URL}/red-master/search?roleType=ASM`,
          requestBody,
        );
        const asms = Array.isArray(res.data) ? res.data : [res.data];
        setAsmList(asms);
        setSelectedAsm([]);
      } catch (err) {
        console.error("Failed to load ASMs:", err);
        setError("Failed to load ASM dropdown data.");
        setAsmList([]);
      } finally {
        setLoadingSubRegion(false);
      }
    };
    fetchAsms();
  }, [selectedRegions, fromDate, toDate]);

  useEffect(() => {
    if (selectedAsm.length === 0) {
      setDistrictList([]);
      setSelectedDistrict([]);
      return;
    }
    const fetchCities = async () => {
      setLoadingCity(true);
      try {
        let url = `${API_CONFIG.BASE_URL}/red-master/asm-cities`;
        const queryParams = selectedAsm
          .map((asm) => `asmNames=${encodeURIComponent(asm.value)}`)
          .join("&");
        url += `?${queryParams}`;
        const requestBody = getMonthRangeBody();
        const res = await apiClient.post(url, requestBody);
        const cities = Array.isArray(res.data) ? res.data : [res.data];
        setDistrictList(cities);
        setSelectedDistrict([]);
      } catch (err) {
        console.error("Failed to load cities:", err);
        setError("Failed to load city dropdown data.");
        setDistrictList([]);
      } finally {
        setLoadingCity(false);
      }
    };
    fetchCities();
  }, [selectedAsm, fromDate, toDate]);

  useEffect(() => {
    if (selectedDistrict.length === 0 || !fromDate || !toDate) {
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }
    const fetchChannels = async () => {
      setLoadingChannel(true);
      setTypeList([]);
      setSelectedTypes([]);
      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedDistrict.map((city) =>
          apiClient.request({
            method: "POST",
            url: `${
              API_CONFIG.BASE_URL
            }/red-master/channels?cities=${encodeURIComponent(city.value)}`,
            data: requestBody,
          }),
        );
        const results = await Promise.all(promises);
        const allChannels = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data],
        );
        const uniqueChannels = [...new Set(allChannels)];
        setChannelList(uniqueChannels);
        setSelectedChannels([]);
      } catch (err) {
        console.error("Failed to load channels:", err);
        setError("Failed to load channel dropdown data.");
        setChannelList([]);
      } finally {
        setLoadingChannel(false);
      }
    };
    fetchChannels();
  }, [selectedDistrict, fromDate, toDate]);

  useEffect(() => {
    if (selectedChannels.length === 0) {
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }
    const fetchType = async () => {
      if (!fromDate || !toDate) {
        return;
      }
      setLoadingType(true);
      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedChannels.map((channel) =>
          apiClient.request({
            method: "POST",
            url: `${
              API_CONFIG.BASE_URL
            }/red-master/store-types?channels=${encodeURIComponent(
              channel.value,
            )}`,
            data: requestBody,
          }),
        );
        const results = await Promise.all(promises);
        const allTypes = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data],
        );
        const uniqueTypes = [...new Set(allTypes)];
        setTypeList(uniqueTypes);
        setSelectedTypes([]);
      } catch (err) {
        console.error("Failed to load types:", err);
        setError("Failed to load type dropdown data.");
        setTypeList([]);
      } finally {
        setLoadingType(false);
      }
    };
    fetchType();
  }, [selectedChannels, fromDate, toDate]);

  const colors = ["red.500", "green.500", "yellow.500", "red.500", "blue.500"];
  const handleEditSave = async () => {
    try {
      if (selectedStoreDetails) {
        handleStoreClick(selectedStore);
      }
    } catch (error) {
      console.error("Failed to refresh after edit:", error);
    }
  };

  const handleRecalculation = async () => {
    if (!selectedStore) {
      toast({
        title: "Select Store",
        description: "Please select a store first",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }
    const runId = scoreBreakdown?.availability?.products?.[0]?.runId;
    const storeId = selectedStore.storeId || scoreBreakdown?.store?.storeId;

    if (!runId || !storeId) {
      toast({
        title: "Missing Data",
        description:
          "Store information is incomplete. Missing runId or storeId.",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
      return;
    }
    try {
      setisRecalculating(true);

      const query = new URLSearchParams({
        runId: runId,
        storeId: storeId,
      }).toString();

      const response = await fetch(
        `https://orgi-dev-api.sconexsoft.com/aicalc/calculate-score?${query}`,
        {
          method: "GET",
        },
      );

      if (!response.ok) {
        throw new Error("API failed");
      }

      await response.text();

      toast({
        title: "Success",
        description: "Stores Calculated Successfully",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });

      handleStoreClick(selectedStore);
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "Recalculation failed",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    } finally {
      setisRecalculating(false);
    }
  };

  const handleValidate = async (auditType, setLoading) => {
    const runId = scoreBreakdown?.availability?.products?.[0]?.runId;
    const storeId =
      selectedStore?.storeId ||
      scoreBreakdown?.store?.storeId ||
      scoreBreakdown?.availability?.products?.[0]?.storeId;

    const auditDate = selectedStoreDetails?.auditedDate;
    const userId =
      localStorage.getItem("userId") || sessionStorage.getItem("userId");

    if (!runId || !storeId || !auditDate || !userId) {
      toast({
        title: "Missing Data",
        description:
          "Required information (runId, storeId, auditDate) is missing.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);

    try {
      const requestBody = {
        runId: Number(runId),
        storeId: Number(storeId),
        auditType,
        auditDate,
        userId: Number(userId),
      };

      await apiClient.post(
        `${API_CONFIG.BASE_URL}/api/audit/validate-store`,
        requestBody,
      );

      toast({
        title: "Success",
        description: "Store validated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      console.error("Validation failed:", err);
      toast({
        title: "Validation failed",
        description: err.response?.data?.message || "Failed to validate store",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Container maxW="container.2xl">
        {/* Filter Section */}
        <Box mt="4">
          <HStack
            spacing={{ base: 3, md: 5 }}
            align="flex-start"
            flexDir={{ base: "column", lg: "row" }}
          >
            {/* Region Select */}
            <Box
              flex="1"
              width={{ base: "100%", lg: "auto" }}
              mb={{ base: 3, lg: 0 }}
              borderRadius="8px"
            >
              <Select
                isMulti
                options={regionOptions}
                value={selectedRegions}
                onChange={(value) => setSelectedRegions(value || [])}
                placeholder="Company Code"
                closeMenuOnSelect={false}
                isClearable
                isLoading={loadingRegions}
                isDisabled={loadingRegions || (!fromDate && !toDate)}
                styles={styles.customSelectStyles}
              />
            </Box>
            {/* ASM Select */}
            <Box
              flex="1"
              width={{ base: "100%", lg: "auto" }}
              mb={{ base: 3, lg: 0 }}
            >
              <Select
                isMulti
                options={asmOptions}
                value={selectedAsm}
                onChange={(value) => setSelectedAsm(value || [])}
                placeholder="ASM"
                closeMenuOnSelect={false}
                isLoading={loadingSubRegion}
                isDisabled={selectedRegions.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>
            {/* Cities/District Select */}
            <Box
              flex="1"
              width={{ base: "100%", lg: "auto" }}
              mb={{ base: 3, lg: 0 }}
            >
              <Select
                isMulti
                options={cityOptions}
                value={selectedDistrict}
                onChange={(value) => setSelectedDistrict(value || [])}
                placeholder="Cities"
                closeMenuOnSelect={false}
                isLoading={loadingCity}
                isDisabled={selectedAsm.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>
            {/* Channels Select */}
            <Box
              flex="1"
              width={{ base: "100%", lg: "auto" }}
              mb={{ base: 3, lg: 0 }}
            >
              <Select
                isMulti
                options={channelOptions}
                value={selectedChannels}
                onChange={(value) => setSelectedChannels(value || [])}
                placeholder="Channels"
                closeMenuOnSelect={false}
                isLoading={loadingChannel}
                isDisabled={selectedDistrict.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>
            {/* Type Select */}
            <Box
              flex="1"
              width={{ base: "100%", lg: "auto" }}
              mb={{ base: 3, lg: 0 }}
            >
              <Select
                isMulti
                options={typeOptions}
                value={selectedTypes}
                onChange={(value) => setSelectedTypes(value || [])}
                placeholder="Type"
                closeMenuOnSelect={false}
                isLoading={loadingType}
                isDisabled={selectedChannels.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>
            {/* Total Outlets Box */}
            <Box
              bg="gray.800"
              color="white"
              px="4"
              py="3"
              borderRadius="lg"
              minW="150px"
              textAlign="center"
              fontWeight="bold"
              boxShadow="sm"
              width={{ base: "100%", lg: "auto" }}
            >
              <Text fontSize="sm" opacity={0.9}>
                Total Outlets
              </Text>
              <Text fontSize="2xl" fontWeight="bold">
                {loadingScores ? <Spinner size="sm" /> : totalOutlets}
              </Text>
            </Box>
          </HStack>
          {/* Score Cards Section */}
          <Flex mt={6} gap={4} flexWrap="wrap">
            {cards.map((card, index) => (
              <Box
                key={card.label}
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{
                  boxShadow: "md",
                  transform: "translateY(-2px)",
                }}
                transition="all 0.2s"
                flex="1"
                minW={{ base: "100%", sm: "45%", md: "auto" }}
              >
                <Text fontSize="sm" fontWeight="medium" color="gray.600">
                  {card.label}
                </Text>
                {loadingScores ? (
                  <Center h="40px">
                    <Spinner size="sm" color={colors[index % colors.length]} />
                  </Center>
                ) : (
                  <Text
                    fontWeight="bold"
                    fontSize="xl"
                    color={colors[index % colors.length]}
                  >
                    {`${card.value}`}
                  </Text>
                )}
              </Box>
            ))}
          </Flex>
        </Box>
        <Flex mt="8" gap={6} flexDir={{ base: "column", lg: "row" }}>
          {/* Stores Section with Search */}
          <Box
            flex="1"
            bg="white"
            borderRadius="xl"
            overflow="hidden"
            boxShadow="sm"
            border="1px solid"
            borderColor="gray.200"
          >
            {/* Search Bar */}
            <Box p={4} borderBottom="1px solid" borderColor="gray.200">
              <Text fontSize="lg" fontWeight="bold" color="gray.800" mb={3}>
                Stores
              </Text>
              <InputGroup maxW="400px">
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input
                  placeholder="Search stores..."
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  bg="white"
                  borderColor="gray.300"
                  focusBorderColor="red.500"
                  _placeholder={{ color: "gray.400" }}
                />
                {searchQuery && (
                  <InputRightElement>
                    <IconButton
                      aria-label="Clear search"
                      size="sm"
                      icon={<CloseIcon />}
                      onClick={() => {
                        setSearchQuery("");
                        setFilteredStores(stores);
                      }}
                      variant="ghost"
                    />
                  </InputRightElement>
                )}
              </InputGroup>
            </Box>
            {/* Stores Table with Pagination */}
            <Box p={0} height="500px" overflow="hidden">
              {loadingStores ? (
                <Flex justify="center" align="center" height="400px">
                  <Spinner size="lg" color="red.600" />
                </Flex>
              ) : (
                <Box height="100%">
                  {/* Table Container */}
                  <Box height="calc(100% - 60px)" overflow="auto">
                    <TableContainer>
                      <Table variant="simple" size="md">
                        <Thead
                          bg="gray.50"
                          position="sticky"
                          top={0}
                          zIndex={1}
                        >
                          <Tr>
                            <Th
                              fontWeight="bold"
                              color="gray.700"
                              borderColor="gray.200"
                            >
                              Store Name
                            </Th>
                            <Th
                              fontWeight="bold"
                              color="gray.700"
                              borderColor="gray.200"
                            >
                              Actions
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {filteredStores
                            .slice(
                              (currentPage - 1) * pageSize,
                              currentPage * pageSize,
                            )
                            .map((store, index) => (
                              <Tr
                                key={store.id || index}
                                role="group"
                                _hover={{ bg: "red.500", color: "white" }}
                                cursor="pointer"
                                onClick={async () => {
                                  await handleStoreClick(store);
                                }}
                                bg={
                                  selectedStoreDetails?.id === store.id
                                    ? "red.50"
                                    : "transparent"
                                }
                              >
                                <Td borderColor="gray.200">
                                  <Text
                                    fontWeight="medium"
                                    color="gray.800"
                                    _groupHover={{ color: "white" }}
                                  >
                                    {store.storeName || "-"}
                                  </Text>
                                </Td>
                                <Td borderColor="gray.200">
                                  <Button
                                    size="sm"
                                    color="red.500"
                                    bg="white"
                                    _groupHover={{
                                      color: "white",
                                      bg: "red.600",
                                    }}
                                    _hover={{
                                      transform: "scale(1.08)",
                                      boxShadow: "lg",
                                    }}
                                    transition="all 0.2s ease-in-out"
                                    colorScheme="red"
                                    variant="outline"
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      await handleStoreClick(store);
                                    }}
                                  >
                                    View
                                  </Button>
                                </Td>
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          {/* Store Details Section with Tabs */}
          <Box
            flex="1"
            bg="white"
            borderRadius="xl"
            overflow="hidden"
            boxShadow="sm"
            border="1px solid"
            borderColor="gray.200"
            height="600px"
          >
            <Tabs
              index={activeTab}
              onChange={(index) => setActiveTab(index)}
              height="100%"
            >
              <TabList
                bg="red.100"
                p={2}
                borderRadius="lg"
                gap={2}
                mx={4}
                mt={4}
                display="flex"
                justifyContent="space-between"
              >
                <Tab
                  flex="1"
                  fontWeight="semibold"
                  fontSize="md"
                  py={3}
                  borderRadius="lg"
                  color="gray.600"
                  gap={2}
                  justifyContent="center"
                  _selected={{
                    bg: "red.600",
                    color: "white",
                    boxShadow: "md",
                  }}
                  _hover={{
                    bg: "red.100",
                    color: "red.600",
                  }}
                >
                  <FiGrid size={18} /> Abstract View
                </Tab>
                <Tab
                  flex="1"
                  fontWeight="semibold"
                  fontSize="md"
                  py={3}
                  borderRadius="lg"
                  color="gray.600"
                  gap={2}
                  justifyContent="center"
                  _selected={{
                    bg: "red.600",
                    color: "white",
                    boxShadow: "md",
                  }}
                  _hover={{
                    bg: "red.100",
                    color: "red.600",
                  }}
                >
                  <FiList size={18} /> Detail View
                </Tab>
              </TabList>
              <TabPanels height="calc(100% - 73px)" overflowY="auto">
                {/* Abstract View Tab */}
                <TabPanel height="100%" p={4}>
                  {selectedStoreDetails ? (
                    <Box height="100%" overflowY="auto">
                      {/* Store Information Section */}
                      <Box mb={6}>
                        <Text
                          fontSize="lg"
                          fontWeight="bold"
                          color="gray.800"
                          mb={4}
                        >
                          Store Details
                        </Text>
                        <Flex
                          direction={{ base: "column", md: "row" }}
                          gap={4}
                          align="stretch"
                          mb={6}
                        >
                          {/* Left: Store Info Card */}
                          <Box
                            p={4}
                            bg="white"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="gray.200"
                            boxShadow="md"
                            flex="1"
                          >
                            <Heading
                              size="sm"
                              mb={4}
                              color="gray.800"
                              fontWeight="bold"
                            >
                              Store Information
                            </Heading>
                            <VStack align="start" spacing={3}>
                              <HStack align="start" spacing={3}>
                                <Icon
                                  as={FiShoppingBag}
                                  color="red.600"
                                  fontSize="20px"
                                />
                                <Box>
                                  <Text
                                    fontSize="xs"
                                    color="gray.500"
                                    fontWeight="medium"
                                  >
                                    Store Name
                                  </Text>
                                  <Text
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="semibold"
                                  >
                                    {selectedStoreDetails?.storeName || "-"}
                                  </Text>
                                </Box>
                              </HStack>
                              <HStack align="start" spacing={3}>
                                <Icon
                                  as={FiTag}
                                  color="green.600"
                                  fontSize="20px"
                                />
                                <Box>
                                  <Text
                                    fontSize="xs"
                                    color="gray.500"
                                    fontWeight="medium"
                                  >
                                    Store Type
                                  </Text>
                                  <Text
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="semibold"
                                  >
                                    {selectedStoreDetails?.storeType || "-"}
                                  </Text>
                                </Box>
                              </HStack>
                              <HStack align="start" spacing={3}>
                                <Icon
                                  as={FiPackage}
                                  color="purple.600"
                                  fontSize="20px"
                                />
                                <Box>
                                  <Text
                                    fontSize="xs"
                                    color="gray.500"
                                    fontWeight="medium"
                                  >
                                    Store Class
                                  </Text>
                                  <Text
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="semibold"
                                  >
                                    {selectedStoreDetails?.storeClass || "-"}
                                  </Text>
                                </Box>
                              </HStack>
                              <HStack align="start" spacing={3}>
                                <Icon
                                  as={FiPackage}
                                  color="yellow.600"
                                  fontSize="20px"
                                />
                                <Box>
                                  <Text
                                    fontSize="xs"
                                    color="gray.500"
                                    fontWeight="medium"
                                  >
                                    Store ID
                                  </Text>
                                  <Text
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="semibold"
                                  >
                                    {selectedStoreDetails?.storeId || "-"}
                                  </Text>
                                </Box>
                              </HStack>
                              {selectedStoreDetails.address && (
                                <HStack align="start" spacing={3}>
                                  <Icon
                                    as={FiMapPin}
                                    color="orange.600"
                                    fontSize="20px"
                                  />
                                  <Box>
                                    <Text
                                      fontSize="xs"
                                      color="gray.500"
                                      fontWeight="medium"
                                    >
                                      Address
                                    </Text>
                                    <Text
                                      fontSize="sm"
                                      color="gray.800"
                                      fontWeight="semibold"
                                    >
                                      {selectedStoreDetails.address}
                                    </Text>
                                  </Box>
                                </HStack>
                              )}
                            </VStack>
                          </Box>
                          {/* Right: Store Scores Card */}
                          <Box
                            p={4}
                            bg="white"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="gray.200"
                            boxShadow="md"
                            flex="1"
                          >
                            <Heading
                              size="sm"
                              mb={4}
                              color="gray.800"
                              fontWeight="bold"
                            >
                              Store Scores
                            </Heading>
                            <SimpleGrid columns={1} spacing={3}>
                              <Box
                                textAlign="center"
                                p={3}
                                bg="green.50"
                                borderRadius="lg"
                                border="1px solid"
                                borderColor="green.200"
                              >
                                <Text
                                  fontSize="sm"
                                  color="green.700"
                                  fontWeight="medium"
                                >
                                  Availability
                                </Text>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color="green.600"
                                >
                                  {selectedStoreDetails?.availabilityScore || 0}
                                </Text>
                              </Box>
                              <Box
                                textAlign="center"
                                p={3}
                                bg="yellow.50"
                                borderRadius="lg"
                                border="1px solid"
                                borderColor="yellow.200"
                              >
                                <Text
                                  fontSize="sm"
                                  color="yellow.700"
                                  fontWeight="medium"
                                >
                                  Activation
                                </Text>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color="yellow.600"
                                >
                                  {selectedStoreDetails?.activationScore || 0}
                                </Text>
                              </Box>
                              <Box
                                textAlign="center"
                                p={3}
                                bg="red.50"
                                borderRadius="lg"
                                border="1px solid"
                                borderColor="red.200"
                              >
                                <Text
                                  fontSize="sm"
                                  color="red.700"
                                  fontWeight="medium"
                                >
                                  Cooler
                                </Text>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color="red.600"
                                >
                                  {selectedStoreDetails?.coolerScore || 0}
                                </Text>
                              </Box>
                              <Box
                                textAlign="center"
                                p={3}
                                bg="blue.50"
                                borderRadius="lg"
                                border="1px solid"
                                borderColor="blue.200"
                                flex={1}
                              >
                                <Text
                                  fontSize="sm"
                                  color="blue.600"
                                  fontWeight="medium"
                                >
                                  Cooler Purity
                                </Text>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color="blue.600"
                                >
                                  {selectedStoreDetails?.coolerPurity || 0}
                                </Text>
                              </Box>
                              <Box
                                textAlign="center"
                                p={3}
                                bg="gray.50"
                                borderRadius="lg"
                                border="1px solid"
                                borderColor="gray.200"
                                flex={1}
                              >
                                <Text
                                  fontSize="sm"
                                  color="gray.600"
                                  fontWeight="medium"
                                >
                                  Cooler Impurity
                                </Text>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color="gray.600"
                                >
                                  {selectedStoreDetails?.coolerImpurity || 0}
                                </Text>
                              </Box>
                              <Box
                                textAlign="center"
                                p={3}
                                bg="purple.50"
                                borderRadius="lg"
                                border="1px solid"
                                borderColor="purple.200"
                                flex={1}
                              >
                                <Text
                                  fontSize="sm"
                                  color="purple.700"
                                  fontWeight="medium"
                                >
                                  Cooler Bonus
                                </Text>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color="purple.600"
                                >
                                  {selectedStoreDetails?.coolerBonus || 0}
                                </Text>
                              </Box>
                            </SimpleGrid>
                          </Box>
                        </Flex>
                      </Box>
                      {/* Store Images Section */}
                      <Box>
                        <Text
                          fontSize="lg"
                          fontWeight="bold"
                          color="gray.800"
                          mb={4}
                        >
                          Store Images
                        </Text>
                        {selectedStoreImages.length > 0 ? (
                          <VStack spacing={4}>
                            {/* Main Image Display */}
                            <Box
                              position="relative"
                              w="full"
                              maxW="480px"
                              mx="auto"
                              borderRadius="xl"
                              overflow="hidden"
                              boxShadow="xl"
                              bg="gray.100"
                            >
                              <Image
                                src={selectedStoreImages[currentImageIndex]}
                                alt={`Store image ${currentImageIndex + 1}`}
                                objectFit="contain"
                                w="100%"
                                h="300px"
                                bg="white"
                                transform={`rotate(${imageRotation}deg)`} // <-- add this
                                transition="transform 0.3s ease"
                              />
                              {/* Rotate Button */}
                              <IconButton
                                aria-label="Rotate image"
                                icon={<Icon as={FiRotateCw} />}
                                position="absolute"
                                top="2"
                                right="10"
                                colorScheme="blue"
                                size="sm"
                                onClick={() =>
                                  setImageRotation((prev) => (prev + 90) % 360)
                                }
                                zIndex={2}
                                title="Rotate"
                              />
                              <IconButton
                                aria-label="Download image"
                                icon={<FiDownload />}
                                position="absolute"
                                top="2"
                                right="2"
                                colorScheme="red"
                                size="sm"
                                onClick={() =>
                                  handleDownloadImage(
                                    selectedStoreImages[currentImageIndex],
                                  )
                                }
                                zIndex={2}
                                title="Download"
                              />
                              {/* Navigation Buttons */}
                              {selectedStoreImages.length > 1 && (
                                <>
                                  <Button
                                    position="absolute"
                                    left="4"
                                    top="50%"
                                    transform="translateY(-50%)"
                                    onClick={() =>
                                      setCurrentImageIndex(
                                        Math.max(0, currentImageIndex - 1),
                                      )
                                    }
                                    isDisabled={currentImageIndex === 0}
                                    size="sm"
                                    bg="whiteAlpha.900"
                                    boxShadow="md"
                                    _hover={{ bg: "white" }}
                                    zIndex={1}
                                  >
                                    <Icon as={FiChevronLeft} boxSize={5} />
                                  </Button>
                                  <Button
                                    position="absolute"
                                    right="4"
                                    top="50%"
                                    transform="translateY(-50%)"
                                    onClick={() =>
                                      setCurrentImageIndex(
                                        Math.min(
                                          selectedStoreImages.length - 1,
                                          currentImageIndex + 1,
                                        ),
                                      )
                                    }
                                    isDisabled={
                                      currentImageIndex ===
                                      selectedStoreImages.length - 1
                                    }
                                    size="sm"
                                    bg="whiteAlpha.900"
                                    boxShadow="md"
                                    _hover={{ bg: "white" }}
                                    zIndex={1}
                                  >
                                    <Icon as={FiChevronRight} boxSize={5} />
                                  </Button>
                                </>
                              )}
                            </Box>
                            {/* Image Counter */}
                            {selectedStoreImages.length > 1 && (
                              <HStack>
                                <Text
                                  fontSize="sm"
                                  color="gray.600"
                                  fontWeight="medium"
                                >
                                  {currentImageIndex + 1} /{" "}
                                  {selectedStoreImages.length}
                                </Text>
                              </HStack>
                            )}
                            {/* Thumbnails */}
                            {selectedStoreImages.length > 1 && (
                              <HStack
                                spacing={2}
                                overflowX="auto"
                                py={2}
                                justify="center"
                              >
                                {selectedStoreImages.map((img, idx) => (
                                  <Box
                                    key={idx}
                                    onClick={() => setCurrentImageIndex(idx)}
                                    cursor="pointer"
                                    opacity={
                                      idx === currentImageIndex ? 1 : 0.5
                                    }
                                    border={
                                      idx === currentImageIndex
                                        ? "2px solid"
                                        : "none"
                                    }
                                    borderColor="red.500"
                                    borderRadius="md"
                                    overflow="hidden"
                                    transition="all 0.2s"
                                    _hover={{ opacity: 0.8 }}
                                  >
                                    <Image
                                      src={img}
                                      alt={`thumb ${idx}`}
                                      w="60px"
                                      h="60px"
                                      objectFit="cover"
                                    />
                                  </Box>
                                ))}
                              </HStack>
                            )}
                          </VStack>
                        ) : (
                          <Center
                            h="200px"
                            bg="gray.50"
                            borderRadius="xl"
                            border="2px dashed"
                            borderColor="gray.300"
                          >
                            <Text color="gray.500" fontWeight="medium">
                              No store images available
                            </Text>
                          </Center>
                        )}
                      </Box>
                    </Box>
                  ) : (
                    <Center height="500px">
                      <Text color="gray.600">
                        Select a store to view details
                      </Text>
                    </Center>
                  )}
                </TabPanel>
                {/* Detail View Tab */}
                <TabPanel height="100%" width="100%" p={4}>
                  <Box textAlign="center" mt={10}>
                    <Text
                      fontSize="lg"
                      fontWeight="bold"
                      color="gray.800"
                      mb={4}
                    >
                      Detail View
                    </Text>
                    <Text color="gray.600" mb={6}>
                      Click the button below to open detailed view in a popup
                    </Text>
                    <Button
                      colorScheme="red"
                      onClick={onOpen}
                      size="lg"
                      leftIcon={<FiExternalLink />}
                    >
                      Open Detail View
                    </Button>
                  </Box>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Flex>
      </Container>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        isCentered
        motionPreset="slideInBottom"
        scrollBehavior="inside"
        blockScrollOnMount={false}
      >
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent
          maxH="90vh"
          bg="white"
          borderRadius="2xl"
          boxShadow="2xl"
          overflow="hidden"
        >
          {/* Modern Header with Gradient */}
          <ModalHeader
            bgGradient="linear(to-r, red.600, red.500)"
            color="white"
            py={6}
            px={8}
            borderBottom="1px solid"
            borderColor="red.700"
          >
            <Flex align="center" justify="space-between">
              <Flex align="center" gap={3}>
                <Icon as={MdStorefront} boxSize={7} />
                <Box>
                  <Heading size="md" fontWeight="bold">
                    Store Detail View
                  </Heading>
                  <Text fontSize="sm" color="red.100" mt={1}>
                    Comprehensive store analytics and visual insights
                  </Text>
                </Box>
              </Flex>
              <IconButton
                aria-label="Close modal"
                icon={<FiX />}
                variant="ghost"
                color="white"
                _hover={{ bg: "red.700" }}
                onClick={onClose}
                size="lg"
              />
            </Flex>
          </ModalHeader>
          <ModalBody px={8} py={6} overflowY="scroll">
            {scoreBreakdown ? (
              <VStack spacing={6} align="stretch">
                {/* Store Overview Card */}
                <Box
                  bg="white"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="lg"
                  p={6}
                  position="relative"
                  overflow="hidden"
                  _before={{
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "6px",
                    height: "100%",
                    bg: "red.600",
                  }}
                >
                  <Flex align="center" mb={4}>
                    <Icon as={MdStore} color="red.600" boxSize={6} mr={3} />
                    <Heading size="md" color="gray.800" fontWeight="semibold">
                      Store Overview
                    </Heading>
                  </Flex>
                  {(() => {
                    const store = scoreBreakdown.store || {};
                    return (
                      <SimpleGrid
                        columns={{ base: 1, md: 2, lg: 3 }}
                        spacing={6}
                      >
                        <InfoCard
                          icon={FiHash}
                          label="Store ID"
                          value={store.storeId || "-"}
                          color="red"
                        />
                        <InfoCard
                          icon={FiTag}
                          label="Store Code"
                          value={store.storeId || "-"}
                          color="green"
                        />
                        <InfoCard
                          icon={MdStore}
                          label="Store Name"
                          value={store.storeName || "-"}
                          color="purple"
                        />
                        <InfoCard
                          icon={FiPackage}
                          label="Store Type - Store Class"
                          value={`${store.storeType || "-"} - ${
                            store.storeClass || "-"
                          }`}
                          color="orange"
                        />
                        <InfoCard
                          icon={FiPackage}
                          label="Cooler Size"
                          value={store.coolerSize || "-"}
                          color="blue"
                        />
                        <InfoCard
                          icon={FiMapPin}
                          label="Address"
                          value={store.storeAddress || "-"}
                          color="red"
                          colSpan={{ base: 1, md: 2, lg: 3 }}
                        />
                      </SimpleGrid>
                    );
                  })()}
                </Box>
                <Grid
                  templateColumns={{ base: "1fr", lg: "1fr" }}
                  gap={6}
                  minH="500px"
                >
                  {/* Left Column - Product Summary */}
                  <Box
                    bg="white"
                    borderRadius="xl"
                    border="1px solid"
                    borderColor="gray.200"
                    boxShadow="lg"
                    p={6}
                    display="flex"
                    flexDirection="column"
                    height="100%"
                  >
                    <Flex align="center" justify="space-between" mb={4}>
                      <Flex align="center">
                        <Icon as={FiGrid} color="red.600" boxSize={6} mr={3} />
                        <Heading
                          size="md"
                          color="gray.800"
                          fontWeight="semibold"
                        >
                          Product Summary
                        </Heading>
                      </Flex>
                      <HStack spacing={3} align="center">
                        <Badge
                          colorScheme="green"
                          variant="subtle"
                          px={3}
                          py={1}
                          borderRadius="full"
                        >
                          availabilityScore:
                          {scoreBreakdown?.availability?.availabilityScore || 0}
                        </Badge>
                        <Badge
                          colorScheme="red"
                          variant="subtle"
                          px={3}
                          py={1}
                          borderRadius="full"
                        >
                          {productSummary.length} items
                        </Badge>
                      </HStack>
                    </Flex>
                    <Box>
                      {productSummary.length > 0 ? (
                        <Box
                          key={selectedStoreDetails?.storeId}
                          borderRadius="lg"
                          overflow="hidden"
                          border="1px solid"
                          borderColor="gray.200"
                        >
                          <ProductTable productSummary={productSummary} />
                        </Box>
                      ) : (
                        <Center h="400px">
                          <VStack spacing={3}>
                            <Icon
                              as={FiPackage}
                              boxSize={12}
                              color="gray.400"
                            />
                            <Text color="gray.600" fontWeight="medium">
                              No products found
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              No product data available for this store
                            </Text>
                          </VStack>
                        </Center>
                      )}
                    </Box>
                  </Box>
                  {/* Right Column - Images - UPDATED SECTION */}
                  <Box
                    bg="white"
                    borderRadius="xl"
                    border="1px solid"
                    borderColor="gray.200"
                    boxShadow="lg"
                    p={6}
                  >
                    {/* Header with Visual Evidence and Shelf Info */}
                    <Flex align="center" justify="space-between" mb={4}>
                      <Flex align="center">
                        <Icon as={FiImage} color="red.600" boxSize={6} mr={3} />
                        <Heading
                          size="md"
                          color="gray.800"
                          fontWeight="semibold"
                        >
                          Visual Evidence
                        </Heading>
                      </Flex>

                      {shelfInfo.length > 0 && shelfInfo[modalImageIndex] && (
                        <Badge
                          colorScheme="red"
                          fontSize="md"
                          px={4}
                          py={2}
                          borderRadius="full"
                          fontWeight="bold"
                        >
                          {shelfInfo[modalImageIndex].label}
                        </Badge>
                      )}
                    </Flex>

                    {/* Images Section */}
                    <HStack spacing={6} mb={4} minH="300px">
                      <ImageCard
                        title="Actual Image"
                        subtitle="Original store photograph"
                        icon={FiEye}
                        imageUrl={actualImageUrl}
                        colorScheme="red"
                      />

                      <ImageCard
                        title="Annotated Image"
                        subtitle="AI-processed analysis"
                        icon={FiCheckCircle}
                        imageUrl={annotatedImageUrl}
                        colorScheme="green"
                      />
                    </HStack>

                    <HStack justify="space-between" mt={4} spacing={4}>
                      <Box width="200px" />
                      <HStack spacing={4}>
                        <IconButton
                          aria-label="Previous image"
                          icon={<FiChevronLeft />}
                          onClick={handlePrevModalImage}
                          isDisabled={modalImageIndex <= 0}
                          colorScheme="red"
                          variant="outline"
                          size="md"
                        />
                        <Text
                          fontSize="md"
                          color="gray.700"
                          fontWeight="semibold"
                          minW="80px"
                          textAlign="center"
                        >
                          {modalActualImages.length > 0
                            ? `${modalImageIndex + 1} / ${
                                modalActualImages.length
                              }`
                            : "0 / 0"}
                        </Text>
                        <IconButton
                          aria-label="Next image"
                          icon={<FiChevronRight />}
                          onClick={handleNextModalImage}
                          isDisabled={
                            modalImageIndex >=
                            Math.max(0, modalActualImages.length - 1)
                          }
                          colorScheme="red"
                          variant="outline"
                          size="md"
                        />
                      </HStack>
                      <Flex align="center" justify="space-between" gap={6}>
                        <Button
                          leftIcon={<FiEdit />}
                          colorScheme="red"
                          variant="outline"
                          size="sm"
                          onClick={onEditOpen}
                          _hover={{
                            bg: "red.50",
                            transform: "translateY(-2px)",
                            boxShadow: "md",
                          }}
                          transition="all 0.2s"
                        >
                          Edit
                        </Button>
                        <EditImageModal
                          isOpen={isEditOpen}
                          onClose={onEditClose}
                          runId={
                            scoreBreakdown?.availability?.products?.[0]?.runId
                          }
                          storeId={
                            scoreBreakdown?.availability?.products?.[0]?.storeId
                          }
                          fileName={scoreBreakdown?.availability?.imagePathResponse?.s3pathActualFile?.[
                            modalImageIndex
                          ]
                            ?.split("/")
                            .pop()}
                          onSave={handleEditSave}
                          auditDate={selectedStoreDetails?.auditedDate}
                        />
                        <Button
                          colorScheme="red"
                          variant="outline"
                          size="sm"
                          onClick={handleRecalculation}
                          isLoading={isRecalculating}
                          loadingText="Recalculating.."
                          _hover={{
                            bg: "red.50",
                            transform: "translateY(-2px)",
                            boxShadow: "md",
                          }}
                          transition="all 0.2s"
                        >
                          ReCalculation
                        </Button>
                        <Button
                          leftIcon={<FiCheckCircle />}
                          colorScheme="green"
                          variant="solid"
                          size="sm"
                          onClick={() =>
                            handleValidate("AVL", setIsValidatingAvl)
                          }
                          isLoading={isValidatingAvl}
                          loadingText="Validating..."
                          _hover={{
                            bg: "green.600",
                            transform: "translateY(-2px)",
                            boxShadow: "md",
                          }}
                          transition="all 0.2s"
                        >
                          Validate
                        </Button>
                      </Flex>
                    </HStack>
                  </Box>
                </Grid>
                {/* Activation Section */}
                <Box
                  bg="white"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="lg"
                  p={6}
                >
                  <Flex align="center" justify="space-between" mb={4}>
                    <Flex align="center">
                      <Icon
                        as={FiCheckCircle}
                        color="yellow.600"
                        boxSize={6}
                        mr={3}
                      />
                      <Heading size="md" color="gray.800" fontWeight="semibold">
                        Activation Details
                      </Heading>
                    </Flex>
                    <Badge
                      colorScheme="blue"
                      fontSize="md"
                      variant="solid"
                      px={4}
                      py={2}
                    >
                      activationScore:{" "}
                      {scoreBreakdown?.activation?.activationScore || 0}
                    </Badge>
                  </Flex>
                  {scoreBreakdown?.activation?.activationDetails?.length > 0 ? (
                    <>
                      <TableContainer>
                        <Table variant="simple">
                          <Thead bg="yellow.50">
                            <Tr>
                              <Th color="yellow.700" fontWeight="bold">
                                Company
                              </Th>
                              <Th color="yellow.700" fontWeight="bold">
                                Brand
                              </Th>
                              <Th color="yellow.700" fontWeight="bold">
                                Product
                              </Th>
                              <Th color="yellow.700" fontWeight="bold">
                                Action
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {scoreBreakdown.activation.activationDetails.map(
                              (detail, idx) => (
                                <Tr
                                  key={idx}
                                  bg={
                                    idx % 2 === 0 ? "yellow.50" : "transparent"
                                  }
                                >
                                  <Td fontWeight="medium">
                                    {detail.product?.productCompany
                                      ?.productCompanyName || "-"}
                                  </Td>
                                  <Td>
                                    {detail.product?.productBrand
                                      ?.productBrandName || "-"}
                                  </Td>
                                  <Td>{detail.product?.productName || "-"}</Td>
                                  <Td>
                                    <Button
                                      size="sm"
                                      colorScheme="yellow"
                                      onClick={() =>
                                        handleViewActivation(detail)
                                      }
                                    >
                                      View
                                    </Button>
                                  </Td>
                                </Tr>
                              ),
                            )}
                          </Tbody>
                        </Table>
                      </TableContainer>
                      <Flex justify="flex-end" mt={6}>
                        <Button
                          leftIcon={<FiCheckCircle />}
                          colorScheme="green"
                          variant="solid"
                          size="md"
                          onClick={() =>
                            handleValidate("ACT", setIsValidatingAct)
                          }
                          isLoading={isValidatingAct}
                          loadingText="Validating..."
                          _hover={{
                            bg: "green.600",
                            transform: "translateY(-2px)",
                            boxShadow: "md",
                          }}
                          transition="all 0.2s"
                        >
                          Validate Activation
                        </Button>
                      </Flex>
                    </>
                  ) : (
                    <Center h="200px" color="gray.500">
                      No activation details available
                    </Center>
                  )}
                </Box>
                {/* Cooler Section */}
                <Box
                  bg="white"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="lg"
                  p={6}
                >
                  <Flex align="center" justify="space-between" mb={4}>
                    <Flex align="center">
                      <Icon as={FiPackage} color="red.600" boxSize={6} mr={3} />
                      <Heading size="md" color="gray.800" fontWeight="semibold">
                        Cooler Shelf Breakdown
                      </Heading>
                    </Flex>
                    <Badge colorScheme="red" variant="solid" px={4} py={2}>
                      coolerScore: {scoreBreakdown?.cooler?.coolerScore || 0}
                    </Badge>
                  </Flex>
                  {scoreBreakdown?.cooler?.shelfWiseCounts?.length > 0 ? (
                    <>
                      <TableContainer>
                        <Table variant="simple">
                          <Thead bg="red.50">
                            <Tr>
                              <Th color="red.700" fontWeight="bold" w="30%">
                                Shelf Number
                              </Th>
                              <Th
                                color="red.700"
                                fontWeight="bold"
                                w="40%"
                                textAlign="center"
                              >
                                Product Percentage
                              </Th>
                              <Th color="red.700" fontWeight="bold" w="30%">
                                Status
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {scoreBreakdown.cooler.shelfWiseCounts.map(
                              (shelf, idx) => (
                                <Tr key={idx}>
                                  <Td fontWeight="medium">
                                    {shelf.shelfNumber}
                                  </Td>
                                  <Td
                                    textAlign="center"
                                    color="green.600"
                                    fontWeight="bold"
                                  >
                                    {shelf.percentage}%
                                  </Td>
                                  <Td>
                                    <Badge
                                      colorScheme={
                                        shelf.result?.toUpperCase() === "PURE"
                                          ? "green"
                                          : "red"
                                      }
                                      variant="subtle"
                                      px={3}
                                      py={1}
                                      borderRadius="full"
                                      fontWeight="bold"
                                    >
                                      {shelf.result}
                                    </Badge>
                                  </Td>
                                </Tr>
                              ),
                            )}
                          </Tbody>
                        </Table>
                      </TableContainer>
                      {/* Cooler Images */}
                      <Box mt={6}>
                        <HStack spacing={6} flex={1}>
                          <ImageCard
                            title="Cooler Actual Image"
                            subtitle="Original cooler photograph"
                            icon={FiEye}
                            imageUrl={coolerActualImageUrl}
                            colorScheme="red"
                          />
                          <ImageCard
                            title="Cooler Annotated Image"
                            subtitle="AI-processed analysis"
                            icon={FiCheckCircle}
                            imageUrl={coolerAnnotatedImageUrl}
                            colorScheme="green"
                          />
                        </HStack>
                        <HStack justify="center" mt={4} spacing={4}>
                          <IconButton
                            aria-label="Previous cooler image"
                            icon={<FiChevronLeft />}
                            onClick={handlePrevCoolerImage}
                            isDisabled={modalCoolerImageIndex <= 0}
                          />
                          <Text fontSize="sm" color="gray.600">
                            {modalCoolerActualImages.length > 0
                              ? `${modalCoolerImageIndex + 1} / ${
                                  modalCoolerActualImages.length
                                }`
                              : "0 / 0"}
                          </Text>
                          <IconButton
                            aria-label="Next cooler image"
                            icon={<FiChevronRight />}
                            onClick={handleNextCoolerImage}
                            isDisabled={
                              modalCoolerImageIndex >=
                              Math.max(0, modalCoolerActualImages.length - 1)
                            }
                          />
                        </HStack>
                      </Box>
                    </>
                  ) : (
                    <Center h="200px" color="gray.500">
                      No cooler data available
                    </Center>
                  )}
                </Box>
              </VStack>
            ) : (
              <Center h="400px">
                <VStack spacing={4}>
                  <Icon as={MdStore} boxSize={16} color="gray.400" />
                  <Text fontSize="lg" color="gray.600" fontWeight="semibold">
                    No Store Data Available
                  </Text>
                  <Text color="gray.500" textAlign="center" maxW="md">
                    Select a store and open detail view to see comprehensive
                    analytics
                  </Text>
                </VStack>
              </Center>
            )}
          </ModalBody>
          {/* Modern Footer */}
          <ModalFooter
            px={8}
            py={4}
            bg="gray.50"
            borderTop="1px solid"
            borderColor="gray.200"
          >
            <Flex w="100%" justify="space-between" align="center">
              <Text fontSize="sm" color="gray.600">
                &copy; 2025 Image Insight. All rights reserved.
              </Text>
              <HStack spacing={3}>
                <Button
                  variant="outline"
                  colorScheme="gray"
                  leftIcon={<FiX />}
                  onClick={onClose}
                  size="lg"
                  px={8}
                  borderRadius="lg"
                >
                  Close
                </Button>
              </HStack>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Activation Image Modal */}
      <Modal
        isOpen={isActivationImageOpen}
        onClose={() => setIsActivationImageOpen(false)}
        isCentered
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Activation Image</ModalHeader>
          <ModalBody>
            {loadingActivationImage ? (
              <Center py={8}>
                <Spinner />
              </Center>
            ) : activationImageUrl ? (
              <Box position="relative">
                <Image
                  src={activationImageUrl}
                  alt="Activation"
                  width="100%"
                  borderRadius="md"
                />
                <IconButton
                  aria-label="Download activation image"
                  icon={<FiDownload />}
                  position="absolute"
                  top="2"
                  right="2"
                  colorScheme="red"
                  size="sm"
                  onClick={() => handleDownloadImage(activationImageUrl)}
                />
              </Box>
            ) : (
              <Center py={8} color="gray.600">
                No image available
              </Center>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsActivationImageOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default SoftDrinkDpEdit;
